// src/components/admin/MetricsCards.jsx
// Cards de resumen: total usuarios, activos, beta, free, MRR, vence, vencidos.
// Recibe `users` (array de docs Firestore /users) ya cargados.

import { useMemo } from 'react';

const MS_PER_DAY = 86400000;

function tsMs(v) {
  if (!v) return null;
  if (typeof v === 'object' && typeof v.seconds === 'number') return v.seconds * 1000;
  if (typeof v === 'number') return v;
  if (typeof v === 'string') {
    const t = new Date(v).getTime();
    return Number.isFinite(t) ? t : null;
  }
  return null;
}

function isTestEmail(email) {
  if (!email) return false;
  const e = String(email).toLowerCase();
  return e.includes('test') || e.includes('prueba');
}

export default function MetricsCards({ users }) {
  const stats = useMemo(() => {
    const now = Date.now();
    let total = 0, admins = 0, activos = 0, beta = 0, free = 0, test = 0;
    let venceProx = 0, vencidos = 0;
    let mrrCents = 0;
    for (const u of users) {
      total += 1;
      if (isTestEmail(u.email)) { test += 1; continue; }
      if (u.role === 'admin') { admins += 1; continue; }
      const access = tsMs(u.accessUntil);
      if (access && access > now) {
        activos += 1;
        if (access - now <= 7 * MS_PER_DAY) venceProx += 1;
        // MRR estimado por plan (CLP)
        const plan = (u.lastPaymentPlan || '').toLowerCase();
        const monthly = plan === 'monthly' ? 9990
                      : plan === 'quarterly' ? 24990 / 3
                      : plan === 'biannual' ? 44990 / 6
                      : 0;
        mrrCents += monthly;
      } else if (access && access <= now) {
        vencidos += 1;
      } else if (u.planType === 'Beta' || u.beta === true) {
        beta += 1;
      } else {
        free += 1;
      }
    }
    return { total, admins, activos, beta, free, test, venceProx, vencidos, mrr: Math.round(mrrCents) };
  }, [users]);

  const fmtCLP = (n) => 'CLP ' + n.toLocaleString('es-CL');

  return (
    <>
      <div className="admin-section">
        <h3 className="admin-section-title">Usuarios</h3>
        <div className="admin-cards">
          <div className="admin-card">
            <div className="admin-card-label">Total</div>
            <div className="admin-card-value">{stats.total}</div>
            <div className="admin-card-foot">{stats.admins > 0 ? `${stats.admins} admin · ${stats.test} test` : `${stats.test} test`}</div>
          </div>
          <div className="admin-card">
            <div className="admin-card-label">Activos</div>
            <div className="admin-card-value">{stats.activos}</div>
            <div className="admin-card-foot">con suscripción vigente</div>
          </div>
          <div className="admin-card">
            <div className="admin-card-label">Beta</div>
            <div className="admin-card-value">{stats.beta}</div>
            <div className="admin-card-foot">acceso por invitación</div>
          </div>
          <div className="admin-card">
            <div className="admin-card-label">Free</div>
            <div className="admin-card-value">{stats.free}</div>
            <div className="admin-card-foot">sin acceso pago</div>
          </div>
        </div>
      </div>
      <div className="admin-section">
        <h3 className="admin-section-title">Ingresos</h3>
        <div className="admin-cards">
          <div className="admin-card">
            <div className="admin-card-label">MRR estimado</div>
            <div className="admin-card-value">{fmtCLP(stats.mrr)}</div>
            <div className="admin-card-foot">basado en planes activos</div>
          </div>
          <div className="admin-card">
            <div className="admin-card-label">Vencen próx 7d</div>
            <div className="admin-card-value">{stats.venceProx}</div>
            <div className="admin-card-foot">requieren renovación</div>
          </div>
          <div className="admin-card">
            <div className="admin-card-label">Vencidos</div>
            <div className="admin-card-value">{stats.vencidos}</div>
            <div className="admin-card-foot">accessUntil pasado</div>
          </div>
        </div>
      </div>
    </>
  );
}
